module.exports = "<routes-page></routes-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/index.html
// module id = 1373
// module chunks = 0